import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { Box } from "../../box/src";
import { primaryShadow } from "../../theme/src";
import { AddOptionalLink } from './components/AddOptionalLink';
import { AddOptionalTooltip } from './components/AddOptionalTooltip';
import { Picture } from './components/Picture';
const Wrapper = styled(Box) `
  user-select: none;

  img {
    border-radius: ${({ $isSquare, theme }) => ($isSquare ? `${theme.themeVariables.globalBorderRadius}px` : '50%')};
    border: solid ${({ $withBorder }) => ($withBorder ? 2 : 0)}px white;
    ${({ $withShadow }) => ($withShadow ? primaryShadow : 'box-shadow: none')};
    width: inherit;
  }
`;
export const Avatar = (_a) => {
    var { alt, dataTestId, fallback, height = '100%', href, isExternalLink = false, isSquare = false, onError, onLoad, position = 'relative', src, state, tooltip, width = '100%', withBorder = false, withShadow = false } = _a, props = __rest(_a, ["alt", "dataTestId", "fallback", "height", "href", "isExternalLink", "isSquare", "onError", "onLoad", "position", "src", "state", "tooltip", "width", "withBorder", "withShadow"]);
    return (_jsx(AddOptionalLink, { href: href, isExternalLink: isExternalLink, children: _jsx(AddOptionalTooltip, { tooltip: tooltip, children: _jsx(Wrapper, Object.assign({ "$isSquare": isSquare, "$withBorder": withBorder, "$withShadow": withShadow, height: height, position: position, width: width }, props, { children: _jsx(Picture, { alt: alt, dataTestId: dataTestId, fallback: fallback, onError: onError, onLoad: onLoad, src: src, state: state }) })) }) }));
};
//# sourceMappingURL=Avatar.js.map